import { useState } from "react";
import { toast } from "sonner";
import { useApi, errMsg } from "@/lib/api";
import { Stars } from "@/components/site/Stars";

export function ReviewBox({ booking, existing, onDone }) {
  const api = useApi();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  if (existing) return (
    <div className="flex flex-wrap items-center gap-3 text-sm" data-testid={`review-done-${booking.id}`}>
      <span className="font-semibold">Your rating</span><Stars value={existing.rating} />
      {existing.comment && <span className="text-neutral-600">“{existing.comment}”</span>}
    </div>
  );
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/bookings/${booking.id}/review`, { rating, comment });
      toast.success("Thanks for rating your trip!");
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="space-y-3" data-testid={`review-box-${booking.id}`}>
      <p className="text-sm font-semibold">How was your trip with the {booking.car_name}?</p>
      <Stars value={rating} onChange={setRating} size="h-7 w-7" testId={`review-stars-${booking.id}`} />
      <textarea rows={2} value={comment} maxLength={1000} onChange={(e) => setComment(e.target.value)} placeholder="Tell others about the car and the service (optional)"
        data-testid={`review-comment-${booking.id}`} className="w-full rounded-xl border border-black/10 bg-white px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#FF5A00]" />
      <button onClick={submit} disabled={!rating || busy} data-testid={`review-submit-${booking.id}`}
        className="rounded-full bg-[#FF5A00] px-5 py-2 text-sm font-semibold text-white transition-colors duration-200 hover:bg-[#e65100] disabled:bg-neutral-300">
        {busy ? "Sending…" : "Submit review"}
      </button>
    </div>
  );
}
